const KeenSlider = window.KeenSlider

const { addWheelControls } = window.BAO.Carousel.plugins

class CollectionSlider extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 3.2,
          spacing: 10,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.5,
              spacing: 10,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4.4,
              spacing: 10,
            },
          },
        },
      },
      [addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('collection-slider')) {
  customElements.define('collection-slider', CollectionSlider)
}
